import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    getSocioStatGeneralRequest: ['response'],
    getSocioStatGeneralSuccess: ['response', 'loading'],
    getSocioStatGeneralFailure: ['error'],
})

export const getSocioStatGeneralTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    response: null,
    success: null,
    error: null,
})

/* ------------- Reducers ------------- */

const getSocioStatGeneralRequest = state => {
    return state.merge({ success: null })
}

const getSocioStatGeneralSuccess = (state, { response }) => {
    return state.merge({
        success: true,
        error: false,
        response: response.data,
    })
}

const getSocioStatGeneralFailure = (state, { error }) => {
    const { response } = error
    return state.merge({
        success: false,
        error: true,
        response,
    })
}

export const reducer = createReducer(INITIAL_STATE, {
    [Types.GET_SOCIO_STAT_GENERAL_REQUEST]: getSocioStatGeneralRequest,
    [Types.GET_SOCIO_STAT_GENERAL_SUCCESS]: getSocioStatGeneralSuccess,
    [Types.GET_SOCIO_STAT_GENERAL_FAILURE]: getSocioStatGeneralFailure,
})
